import {StyleSheet} from 'react-native';

import {darkGray} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flexShrink: 1,
    minWidth: 0,
    width: '100%',
  },
  textWrapper: {
    flexShrink: 1,
    minWidth: 0,
    width: '100%',
  },
  inlineSourceText: {
    flexShrink: 1,
    minWidth: 0,
    width: '100%',
  },
  sourceStyle: {
    color: darkGray,
  },
  focused: {
    textDecorationLine: 'underline',
  },
});
